// extracted by mini-css-extract-plugin
export var cost = "style-module--cost--56125";
export var cost__bigNum = "style-module--cost__big-num--2fd81";
export var cost__block = "style-module--cost__block--f296d";
export var cost__cena = "style-module--cost__cena--c5835";
export var cost__coursePrice = "style-module--cost__course-price--a8b98";
export var cost__description = "style-module--cost__description--65d50";
export var cost__form = "style-module--cost__form--bb65a";
export var cost__info = "style-module--cost__info--39e15";
export var cost__item = "style-module--cost__item--faf20";
export var cost__price = "style-module--cost__price--86dab";
export var cost__rassrocka = "style-module--cost__rassrocka--cd646";